import styled from "styled-components";
import Color from "../../../assets/Colors";
import Text from "../../../styles/Text";
import Button from "../../../styles/Button";

export const VerifyStyled = styled.section`
   width: 80%;
   margin: 0 auto;
   padding: 4em 0;
   height: 100%;

   .logo {
      margin-left: -1.5%;
      margin-bottom: 3em;
   }

   .title {
      margin-bottom: 1em;
   }
   .text {
      margin-bottom: 1em;
   }
   .ageForm {
      padding: 2em 0;
      margin: 1em 0;
   }

   input {
      font-size: 2em;
      padding: 0.5em;
      font-weight: 100;
      color: ${Color.textColor};
      outline: 0;
      border 0;
      border-bottom: 1px solid ${Color.textColor};
      margin-bottom: 1em;
   }

   .line {
      height: 100%;
      border-left: 1px solid ${Color.textColor};
   }

   input[name="month"]{
      width: 3em;
      margin: 0 1em;
   }

   input[name="day"]{
      width: 3em;
      margin-right: 1em;
   }
   input[name="year"] {
      width: 3.5em;
      margin-left: 1em;
   }

   form button {
      margin: 1em 0;
   }

   @media screen and (max-width: 500px) {
      width: 90%;
      padding: 1em 0;

      & .logo{
         width: 180px;
         margin-bottom: 1.5em;
      }

      & ${Text}{
         &.title {
            font-size: 1.3em;
         }
         &.text {
            font-size: 0.7em;
         }
      }

      & .ageForm {
         margin-bottom: 0;
         
         & > div {
            padding: 2em 0;
            display: flex;
            justify-content: space-between;
            align-items: center;

            & .line {
               height: 1.5em;
            }
         }

         & input {
            font-size: 1em;
            margin-bottom: 0;
            width: 25%
         }

         input[name="month"]{
            width: 15%
         }
      
         input[name="day"]{
            width: 15%;
         }

         & input[name="year"] {
            width: 25%;
            margin-left: 1em;
         }

         & ${Button}{
            margin-top: 2em;
            margin-bottom: 0;
            width: 100%;
            background: ${Color.primary};
            color: white;
            font-weight: 200;
            padding: 0.5em 0;
         }

      }

      & ${Text} {
         &.disc {
            margin-top: 0;
         }
      }

   }

   
`;
